import type {ReactElement} from 'react';
import type {VoidFunction} from '@Components/login-page/login-page.types';
import {Text, TextSize} from '../text';
import {Button, ButtonSize, ButtonType} from '@Components/button';
import styles from './auth-form-footer-cta.module.scss';

/**
 Renders a row with text and a CTA to be used in Auth forms
 */
interface AuthFormFooterCtaProps {
  text: string;
  btnText: string;
  onClick: VoidFunction;
  icon?: string;
  'data-testid'?: string;
  btnTestId?: string;
}

export function AuthFormFooterCta({text, btnText, onClick, icon = '', 'data-testid': dataTestId, btnTestId}: AuthFormFooterCtaProps): ReactElement {
  return (
    <div className={`flex-row-align-center -fullwidth ${styles.formFooter}`} data-testid={dataTestId}>
      <Text val={text} className={`content-body ${styles.text}`} size={TextSize.XSMALL} />
      <div className={`flexbox flex-content-end ${styles.btnContainer}`}>
        <Button
          data-testid={btnTestId}
          text={btnText}
          size={ButtonSize.MEDIUM}
          type={ButtonType.SECONDARY}
          customClasses={`flex-row-justify-center flex-items-center flex-1 border-s-darker ${styles.btn}`}
          textClasses={`body-md-bold ${styles.btnText}`}
          icon={icon}
          onClick={onClick}
        />
      </div>
    </div>
  );
}
